module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dialogues"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "crumbles"
    }
  }, [_c('h2', [_vm._v("Crumbles")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "98%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "7%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "78%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_vm._v("M=man W=woman")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("W:")]), _vm._v(" "), _c('td', [_vm._v("What is the matter dear?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("M:")]), _vm._v(" "), _c('td', [_vm._v("My foot hurts.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("W:")]), _vm._v(" "), _c('td', [_vm._v("From what dear?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("M:")]), _vm._v(" "), _c('td', [_vm._v("I am not sure. But I think it was from yesterday.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("W:")]), _vm._v(" "), _c('td', [_vm._v("You should have said something. So what happened?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("M:")]), _vm._v(" "), _c('td', [_vm._v("The Golden Fumbles cookie truck ran over it.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("W:")]), _vm._v(" "), _c('td', [_vm._v("I guess that’s the way your foot under the Fumbles crumbles!")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 72
// module chunks = 0